import React from 'react';
import { useCurrentUser, useTranslate } from '@hooks';
import { camelCase } from 'lodash';
import { DetailsBlock, NetworkBillingRegionIcon } from '@dotone/react-ui-core';

const UserAccount = () => {
  const { t } = useTranslate('network', 'model');
  const { currentUser } = useCurrentUser();

  const {
    name,
    subscription,
    subscriptionEndDate,
    paymentTerm,
    billingCurrencyCode,
    billingRegion,
  } = currentUser;

  return (
    <div>
      <DetailsBlock
        label={t('name')}
        content={name}
        labelProps={{
          hintProps: { t, tKey: 'profile:edit.hints.companyName', iconProps: { size: 14 } },
        }}
      />
      <DetailsBlock
        label={t('subscription')}
        content={t(`network:subscription.${camelCase(subscription)}`)}
      />
      {subscriptionEndDate && (
        <DetailsBlock date label={t('subscriptionEndDate')} content={subscriptionEndDate} />
      )}
      <DetailsBlock
        label={t('paymentTerm')}
        content={paymentTerm ? t(`network:paymentTerm.${camelCase(paymentTerm)}`) : null}
      />
      <DetailsBlock label={t('billingCurrency')} content={billingCurrencyCode} />
      <DetailsBlock
        label={t('billingRegion')}
        content={billingRegion && <NetworkBillingRegionIcon value={billingRegion} />}
      />
    </div>
  );
};

export default UserAccount;
